import { UserPermissionsResponseDto } from '../../api/kmsapiclient'

import { BaseActionType, GET_USER_PERMISSIONS_SUCCESS } from './actionTypes'

export const getUserPermissionsSuccess = (
  userPermissions: UserPermissionsResponseDto,
): BaseActionType => ({
  type: GET_USER_PERMISSIONS_SUCCESS,
  payload: userPermissions,
})
